var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBaselineTrendingUpBigCircle64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23L41.435 26.435L34.115 33.755L28.115 27.755L17 38.885L19.115 41L28.115 32L34.115 38L43.565 28.565L47 32V23H38Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineTrendingUpBigCircle64Px);
export default __webpack_public_path__ + "static/media/ic_baseline-trending_up_big_circle-64px.36b5882e5386ec32a59d1e7acc37f59f.svg";
export { ForwardRef as ReactComponent };